<script setup>
import { computed, ref, watch } from 'vue';
import ContactAPI from 'dashboard/api/contacts';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  person: { type: Object, required: true },
  size: { type: Number, default: 28 },
  hideOfflineStatus: { type: Boolean, default: true },
});

const contact = ref(null);

const normalizeEmail = value => String(value || '').trim().toLowerCase();
const email = computed(() => normalizeEmail(props.person?.email));
const avatarName = computed(
  () => contact.value?.name || props.person?.name || email.value
);

let lookupVersion = 0;
watch(
  email,
  async value => {
    const version = ++lookupVersion;
    contact.value = null;
    if (!value) return;

    try {
      const {
        data: { payload = [] },
      } = await ContactAPI.search(value, 1, 'name');
      if (version !== lookupVersion) return;
      contact.value = payload.find(
        candidate => normalizeEmail(candidate?.email) === value
      );
    } catch {
      // The roster still works from its Firestore name/email when a lookup fails.
    }
  },
  { immediate: true }
);
</script>

<template>
  <Avatar
    :name="avatarName"
    :src="contact?.thumbnail || ''"
    :size="size"
    :status="contact?.availability_status || null"
    :hide-offline-status="hideOfflineStatus"
    rounded-full
  />
</template>
